angular
	.module 'App.Repository'
	.factory 'CashMovementEventReasonRepository', ['BaseRepository', (BaseRepository) ->
		class CashMovementEventReasonRepository extends BaseRepository
			@resource = '/cash_movement_event_reasons'
			@isRestricted = true

		return new CashMovementEventReasonRepository
	]
